import useSWR from "swr";
import { AgentService } from "@/services/agent/agent.service";
import { defaultSWROption } from "@/services/api/api.service";

export const useCommand = (commandId: string | null) => {
  const fetcher = async () => {
    if (!commandId) return null;
    return await AgentService.getCommand(commandId);
  };

  const { data, error, isLoading, mutate } = useSWR(
    commandId ? ["agent", "command", commandId] : null,
    fetcher,
    defaultSWROption,
  );

  return {
    command: data ?? null,
    error,
    isLoading,
    mutate,
  };
};
